<template>
    <div class="content content-fixed content-auth mt-15">
        <div class="container">
            <div class="media align-items-stretch justify-content-center ht-100p pos-relative">
                <div class="media-body align-items-center d-none d-lg-flex">
                    <div class="mx-wd-600">
                        <img src="../../assets/img/1.png" class="img-fluid" alt="">
                    </div>

                </div><!-- media-body -->
                <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
                    <div class="mx-wd-600">
                        <companies-card></companies-card>
                    </div>
                </div><!-- sign-wrapper -->
            </div><!-- media -->
        </div><!-- container -->
    </div>

</template>

<script>
    import VueElementLoading from 'vue-element-loading'
    import CompaniesCard from "../../components/card/CompaniesCard";
    import {mapState} from 'vuex'
    export default {
        name: "CompanyList",
        components:{
            // eslint-disable-next-line vue/no-unused-components
            VueElementLoading,
            CompaniesCard
        },
        data() {
            return {
                companies:null,
                accounts:null,
                ld: this.$store.state.company["accountsLoading"],
                model: {
                    // orgUserID: this.system.userInfo.id,
                    requestType: 'company',
                    username: '',
                    password: '',
                    countrycode: '234',
                    subscribe: true
                },
                model1: {
                    // userID: this.system.userInfo.id,
                    requestType: 'account',
                    username: '',
                    subscribe: true
                },
            }
        },
        methods: {
            // eslint-disable-next-line no-unused-vars
            viewAccount(_account) {
                // console.log("View Account ==>", _account)
            },
            addNewComapny() {
                this.$router.push('company-new')
            },
            async readCompaniesNAccount() {
                await this.$store.dispatch('system/updateUserInfo', null, {root: false})
                if (this.system.userInfo != null) await this.$store.dispatch("company/updateCompanies", {
                    userID: this.system.userInfo.id,
                    requestType: 'company'
                }, {root: false})
                if (this.system.userInfo != null) await this.$store.dispatch("company/updateAccounts", {
                    userID: this.system.userInfo.id,
                    requestType: 'account'
                }, {root: false})
                // console.log(this.company.companies)
                // console.log(this.company.accounts)
            },
            async navigate2dashboard(orgID, accID) {
                localStorage.orgID = orgID
                localStorage.accID = accID
                await this.$store.dispatch("system/updateIsDashboardUpt", false, {root: true})
                this.$router.push("/dashboard")
            },
            async createLiveFintech(){
                this.model1.customerid = this.company.account[0].accCustID
                this.model1.debitaccount = this.company.account[0].accNumber
                this.model1.env = 'prod'
                await this.$store.dispatch("setting/createFintechCustomer", this.model1, {root: true})
                // this.$router.push("/dashboard")
            },
            async updateFintech(){
                this.model1.customerid = this.company.account[0].accCustID
                this.model1.debitaccount = this.company.account[0].accNumber
                this.model1.env = 'prod'
                await this.$store.dispatch("setting/updateFintechCustomer", this.model1, {root: true})
            },
            async saveChangesLive(){
                this.model1.apiKeyWebhook = this.setting.apiKeys.apikeyLiveWebhook
                this.model1.apiKeyCallback = this.setting.apiKeys.apikeyLiveCallback
                this.model1.apiKeyAccountNumber = this.company.account[0].accNumber
                this.model1.env = 'prod'
                await this.$store.dispatch("setting/saveChanges", this.model1, {root: true})
            },
            accountFiltered(orgID) {
                return this.company.accounts.filter(function (el) {
                    return el.accOrgID == orgID.toString();
                });
            },
            accountCurrent(accID) {
                return this.company.accounts.filter(function (el) {
                    return el.accID == accID;
                });
            },
            navigate(_orgID){
                localStorage.orgID = _orgID
                window.location = '/dashboard'
                //this.$router.push('/dashboard')
            }
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'officer',
            ]),
        },
        mounted() {
            this.readCompaniesNAccount()
            console.log("companiesLoading>>>>>>",this.system.userInfo)
        }
    }
</script>

<style scoped>

</style>